/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentPlanMetadata
 */
export interface PaymentPlanMetadata {
    /**
     * 
     * @type {string}
     * @memberof PaymentPlanMetadata
     */
    description?: string;
}

/**
 * Check if a given object implements the PaymentPlanMetadata interface.
 */
export function instanceOfPaymentPlanMetadata(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaymentPlanMetadataFromJSON(json: any): PaymentPlanMetadata {
    return PaymentPlanMetadataFromJSONTyped(json, false);
}

export function PaymentPlanMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentPlanMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function PaymentPlanMetadataToJSON(value?: PaymentPlanMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
    };
}

